import React from 'react';
import { isFeatureEnabled } from '@/config/featureFlags.service';
import { Feature } from '@/config/featureFlags.definition';
import DataTableFooterNew from './DataTableFooterNew';
import DataTableFooterOld from './DataTableFooterOld';

interface DataTableFooterProps {
  onPageChange: (p: number) => void;
  pageSize: number;
  totalItemsCount: number;
  currentPage: number;
  currentPageItemsCount: number;
  itemLabel?: string;
  isFloating: boolean;
  /** See DataTableFooterNewProps - only meaningful for the new (floating) footer. */
  floatingBackgroundClassName?: string;
}

const DataTableFooter: React.FC<DataTableFooterProps> = ({
  isFloating,
  floatingBackgroundClassName,
  ...props
}) => {
  const useNewFooter = isFeatureEnabled(Feature.SELECTED_ACCOUNT);

  if (useNewFooter) {
    return (
      <DataTableFooterNew
        {...props}
        isFloating={isFloating}
        floatingBackgroundClassName={floatingBackgroundClassName}
      />
    );
  }

  return <DataTableFooterOld {...props} itemLabel={props.itemLabel || 'Records'} />;
};

export default DataTableFooter;
